import { AppState } from '../appState';

export const isNotificationChannelSubscriptionPendingSelector = (state: AppState): boolean =>
    state.pushNotifications.pendingChannelSubscriptionUpdate;
